import { TncPrivacyState } from "./TncPrivacyEntities";

/** Initial value of TncState */
export const InitTncPrivacyState: TncPrivacyState = { };